import React from 'react';
import { Route, Switch, Router } from 'react-router-dom';

import HomePageConnector from './containers/home-page-connector';
import UserLoginConnector from './containers/user-login-connector';
import UserSignUpConnector from './containers/user-signup-connector';
import SendEmail from './containers/send-email-connector';
import ProductListConnector from './containers/product-list-connector';
import StoreProductsConnector from './containers/store-products-connector';
import ComingSoonConnector from './containers/coming-soon-connector';
import NotFoundConnector from './containers/not-found-connector';
import RegisterConfirmation from './containers/register-confirmation-connector';
import ForgotPasswordConnector from './containers/forgot-password-connector';

import ProductShowConnector from './containers/product/product-show-connector';
import CartShowConnector from './containers/cart/cart-show-connector';
import AddressFormConnector from './containers/checkout-steps/address-form-connector';
import DeliveryFormConnector from './containers/checkout-steps/delivery-form-connector';
import PaymentFormConnector from './containers/checkout-steps/payment-form-connector';
import CheckoutConfirmationConnector from './containers/checkout-steps/confirmation-form-connector';
import CheckoutSuccessConnector from './containers/checkout-steps/checkout-success-connector';
import OrderListConnector from './containers/order/list-connector';
import OrderShowConnector from './containers/order/show-connector';
import ShowStoresConnecter from './containers/show-stores-connector';

import PrivacyPolicyConnector from './containers/privacy-policy-connector';
import ShippingPolicyConnector from './containers/shipping-policy-connector';
import ReturnPolicyConnector from './containers/return-policy-connector';
import FrequentQuestionsConnector from './containers/frequent-questions-connector';
import TermsConditionsConnector from './containers/terms-conditions-connector';

import HeaderConnector from './containers/header-connector';
import FooterConnector from './containers/footer-connector';

import APP_ROUTES from './constants/app-routes';
import CheckoutFailConnector from './containers/checkout-steps/checkout-fail-connector';
import PaymentStepConnector from './containers/checkout-steps/payment-step-connector';
import PaymentRedsysRedirectOkConnector from './containers/checkout-steps/payment-redsys-redirect-ok-connector';
import PaymentRedsysRedirectKoConnector from './containers/checkout-steps/payment-redsys-redirect-ko-connector';
import AffidavitCertificationConnector from './containers/affidavit-certification-connector';

import ManageKWalletConnector from './containers/k-wallet';
import AddFundsKWalletConnector from './containers/k-wallet/add-funds-k-wallet-connector';

export default function configRoutes() {
    return (
        <div>
            <HeaderConnector />
            <Switch>
                {/* Homepage */}
                <Route exact path={APP_ROUTES.homePageRoute} component={HomePageConnector} />

                {/* Manager K Wallet */}
                {process.env.REACT_APP_KWALLET_ENABLED === 'true' && <Route exact path={APP_ROUTES.manageKWallet} component={ManageKWalletConnector} />}

                {/* Add Funds K Wallet */}
                {process.env.REACT_APP_KWALLET_ENABLED === 'true' && <Route exact path={APP_ROUTES.addFundsKWallet} component={AddFundsKWalletConnector} />}

                {/* StoresPage */}
                <Route exact path="/stores" component={ShowStoresConnecter} />

                {/* Sign In */}
                {process.env.REACT_APP_DISABLE_AUTH !== 'true' && <Route exact path={APP_ROUTES.signin} component={UserLoginConnector} />}

                {/* Sign Up */}
                {process.env.REACT_APP_DISABLE_AUTH !== 'true' && <Route exact path={APP_ROUTES.signup} component={UserSignUpConnector} />}
                {process.env.REACT_APP_DISABLE_AUTH !== 'true' && <Route exact path="/c/:token" component={RegisterConfirmation} />}

                {/* Send Forgot Password Email */}
                {process.env.REACT_APP_DISABLE_AUTH !== 'true' && <Route exact path={APP_ROUTES.sendEmail} component={SendEmail} />}
                {process.env.REACT_APP_DISABLE_AUTH !== 'true' && <Route exact path="/p/:token" component={ForgotPasswordConnector} />}

                {/* Search */}
                <Route path={APP_ROUTES.searchPageRoute} component={ProductListConnector} />

                {/* Show Product */}
                <Route exact path="/products/:productId" component={ProductShowConnector} />

                {/* Cart */}
                <Route exact path={APP_ROUTES.cartPageRoute} component={CartShowConnector} />

                {/* Checkout */}
                <Route exact path={APP_ROUTES.checkout.addressPageRoute} component={AddressFormConnector} />
                <Route exact path={APP_ROUTES.checkout.deliveryPageRoute} component={DeliveryFormConnector} />
                <Route exact path={APP_ROUTES.checkout.paymentPageRoute} component={PaymentStepConnector} />
                <Route exact path={APP_ROUTES.checkout.confirmPageRoute} component={CheckoutConfirmationConnector} />
                <Route exact path={APP_ROUTES.checkout.completePageRoute} component={CheckoutSuccessConnector} />
                <Route exact path={APP_ROUTES.checkout.failPageRoute} component={CheckoutFailConnector} />
                <Route exact path={APP_ROUTES.checkout.redsysRedirectOk} component={PaymentRedsysRedirectOkConnector} />
                <Route exact path={APP_ROUTES.checkout.redsysRedirectKo} component={PaymentRedsysRedirectKoConnector} />

                <Route exact path={APP_ROUTES.ordersPageRoute} component={OrderListConnector} />
                <Route exact path="/orders/:orderId" component={OrderShowConnector} />

                <Route exact path={APP_ROUTES.wishList} component={ComingSoonConnector} />
                <Route exact path={APP_ROUTES.classifiedAds} component={ComingSoonConnector} />
                <Route exact path="/brand/*" component={ComingSoonConnector} />

                {/* Privacy Policy */}
                <Route exact path={APP_ROUTES.policy} component={PrivacyPolicyConnector} />

                {/* Shipping Policy */}
                <Route exact path={APP_ROUTES.shipping} component={ShippingPolicyConnector} />

                {/* Return Policy */}
                <Route exact path={APP_ROUTES.returns} component={ReturnPolicyConnector} />

                {/* Frequent Questions */}
                <Route exact path={APP_ROUTES.frequentQuestions} component={FrequentQuestionsConnector} />

                {/* Terms Conditions */}
                <Route exact path={APP_ROUTES.terms} component={TermsConditionsConnector} />

                {/* Affidavit Certification */}
                <Route exact path={APP_ROUTES.affidavitCertification} component={AffidavitCertificationConnector} />

                {/* Store Products */}
                <Route path="/:storeCode" component={StoreProductsConnector} />

                <Route component={NotFoundConnector} />
            </Switch>
            <FooterConnector />
        </div>
    );
}



/** WEBPACK FOOTER **
 ** ./src/routes.jsx
 **/